// extracted by mini-css-extract-plugin
export default {"column":"ErrorBoundary-module__column___vfq9a"};